import styled, { css } from 'styled-components';
import { Popover, Spinner as SpinnerBootstrap } from 'reactstrap';
import colors from '../../../../includes/colors';

export const ButtonShow = styled.button`
  font-size: 0.875rem;
  border: solid 1px #ced4da;
  color: ${colors.paleBlue};
  background-color: ${colors.paleGray};
  cursor: pointer;
  display: inline-block;
`;

export const SpinnerContainer = styled.div`
  height: 155px;
  width: 355px;
`;
export const Spinner = styled(SpinnerBootstrap)`
  color: ${colors.blue};
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -12.5px;
  margin-top: -12.5px;
  width: 25px;
  height: 25px;
`;

export const LoginForm = styled.div`
  padding-top: 13px;
  margin-bottom: 0;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 13px;

  input {
    display: block;
    width: 100%;
    height: calc(1.5em + 1rem + 2px);
    padding: 0.5rem 1rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-bottom: 12px;
  }
  button {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    margin-bottom: 10px;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    color: #fff;
    background-color: #007db8;
    border-color: #007db8;
    &:hover {
      color: #fff;
      background-color: #006392;
      border-color: #005a85;
    }
  }
  label {
    color: ${colors.strongGray};
    font-weight: 400;
    display: block;
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
  }
`;

export const FormHelpText = styled.a`
  font-size: 0.875rem;
  color: #007db8;

  &:hover {
    text-decoration: none;
  }

  ${props =>
    props.marginleft &&
    css`
      margin-left: 0.5rem;
    `}

  ${props =>
    props.big &&
    css`
      font-size: 1rem;
      font-weight: 400;
    `}
`;

export const TooltipBox = styled(Popover)`
  .popover {
    box-shadow: 2px 2px 21px -5px rgba(0, 0, 0, 0.2) !important;
    border-radius: 0.3rem !important;
    padding: 0.5rem;
    font-size: 0.875rem;
  }
  .arrow {
    transform: translateX(-30px);
  }
`;

export const CreateProfile = styled.div`
  background-color: #eeeeee;
  padding: 0.6rem 20%;
  -webkit-box-pack: justify;
  justify-content: space-between;
  font-size: 1.125rem;
  font-weight: 300;
  padding-left: 1.25rem;
  padding-right: 1.25rem;

  a {
    margin-left: 0.5rem;
    font-size: 1rem;
    font-weight: 400;
  }
`;
